module.exports = __webpack_public_path__ + "static/share-37b9e9ec9f77b556e42351c498541572.png";